module.exports = __webpack_public_path__ + "img/cookation-logo.ad7be7a3.png";